import { get } from 'lodash-es';
import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { UntypedFormBuilder, UntypedFormGroup, Validators, ValidatorFn, UntypedFormControl } from '@angular/forms';
import { BidiService } from '../../../core/i18n/bidi.service';

@Component({
  standalone: false,
  selector: 'gd-label-value-edit-modal',
  templateUrl: './label-value-edit-modal.component.html',
  styleUrls: ['./label-value-edit-modal.component.scss'],
})
export class LabelValueEditModalComponent implements OnInit {
  title: string;

  validation = {
    duplicate: false,
  };

  editForm: UntypedFormGroup = this.fb.group(
    {
      label: ['', Validators.required],
      value: ['', [Validators.required]],
    },
    { validators: getDuplicationValidator(this.dialogInputData.usedItems || [], this.validation) }
  );

  get keyLabel() {
    return get(this.dialogInputData, 'uiText.keyLabel', 'Label');
  }

  get valueLabel() {
    return get(this.dialogInputData, 'uiText.valueLabel', 'Value');
  }

  get fieldLabelControl() {
    return <UntypedFormControl>this.editForm.get('label');
  }

  get fieldValueControl() {
    return <UntypedFormControl>this.editForm.get('value');
  }

  dir$ =  this.bidiService.getEffectiveLocaleDirectionality();

  constructor(
    @Inject(MAT_DIALOG_DATA) public dialogInputData: any,
    private dialogRef: MatDialogRef<LabelValueEditModalComponent>,
    private fb: UntypedFormBuilder,
    private bidiService: BidiService
  ) {}

  ngOnInit() {
    this.title = this.dialogInputData.title;
    this.editForm.patchValue(this.dialogInputData.item);
  }

  save() {
    if (this.editForm.invalid) {
      return this.editForm.markAllAsTouched();
    }

    return this.dialogRef.close({ item: this.editForm.value });
  }

  cancel() {
    return this.dialogRef.close();
  }
}

function getDuplicationValidator(usedItems: any, validation: any): ValidatorFn {
  return (formGroup: UntypedFormGroup): { [key: string]: boolean } | null => {
    if (formGroup.pristine || formGroup.invalid) {
      return null;
    }
    const item = formGroup.value;
    const similarExists = !!usedItems.find(
      (li) => li.label === item.label || li.value === item.value
    );
    formGroup.markAllAsTouched();
    return similarExists ? { duplicateItem: true } : null;
  };
}

export function setErrors(error, newError): any {
  const tmpError = { ...error, ...newError };
  const returnValueError = Object.keys(tmpError).length === 0 ? null : tmpError;
  return returnValueError;
}
